// @ts-ignore
import * as animationData from "./resultLoading.json";
export default animationData;
